import * as React from "react"
import { Link, useTranslation, useI18next } from "gatsby-plugin-react-i18next"

import SearchInterface from "./searchInterface"

const Header = ({ siteTitle, isSidebarOpen, setSidebarOpen }) => {
  const { t, language } = useTranslation()
  const { languages, changeLanguage } = useI18next()
  return (
    <header className="w-full bg-tomato sticky top-0 z-10">
      <div className="flex justify-between p-2 text-white mx-auto max-w-[1280px]">
        <Link
          to="/"
          className="text-white hover:text-white px-2 text-xl font-bold"
        >
          {t("siteTitle")}
        </Link>
        <Link
          to="/about"
          language={language}
          className="hover:text-darker-sage self-center font-semibold"
        >
          {t("aboutLink")}
        </Link>
        <div className="self-end flex mr-4 items-start mb-2">
          <div className="languages flex self-end mr-2 items-bottom">
            {languages.map(lng => (
              <div key={lng}>
                <button
                  className={`mx-2 block uppercase font-bold text-sm ${
                    lng === t("lang")
                      ? "border-b cursor-default"
                      : "hover:text-black"
                  }`}
                  onClick={e => {
                    e.preventDefault()
                    changeLanguage(lng)
                  }}
                >
                  {lng}
                </button>
              </div>
            ))}
          </div>
          <SearchInterface />
        </div>
      </div>
    </header>
  )
}
export default Header
